import Booking from '../views/booking/partner/Booking';
import ListNotification from '../views/listNotification/ListNotification';
import Partner from '../views/vehiclePartner/partner/Partner';
import VehiclePartner from '../views/vehiclePartner/partner/VehiclePartner';
import Deposit from '../views/booking/Deposit';

const PartRoutes = [
  {
    path: '/vehicle-partner',
    name: 'Quản lý xe',
    icon: 'pe-7s-car',
    component: VehiclePartner,
  },
  {
    path: '/edit-partner-info',
    name: 'Cập nhật thông tin',
    icon: 'pe-7s-info',
    component: Partner,
  },
  {
    path: '/booking',
    name: 'Đơn đặt',
    icon: 'pe-7s-bell',
    component: Booking,
  },

  {
    path: '/notify',
    name: 'Thông báo',
    icon: 'pe-7s-bell',
    component: ListNotification,
  },
];

export default PartRoutes;
